import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import Button from 'react-bootstrap/Button';
import { getUserName } from '@redux/selectors/UserSelector';

import GAEventTracking from '@components/tracking/GAEventTracking';

const TrainingWidget = props => {
  const { url = '#' } = props;
  const username = useSelector(getUserName);
  const gaEventTracker = GAEventTracking('User');

  return (
    <div className="panel-content text-center rounded" style={{ minHeight: '231px' }}>
      <i className="fal fa-users-class fa-6x mb-4 text-info" />
      <p className="mb-5">Guides & Videos, Training Courses and Webinars</p>
      <Button
        onClick={() => {
          if (url) {
            window.open(`${url}`, '_blank');
            gaEventTracker('Opened Training', `${username}`);
          }
        }}
        variant="primary"
      >
        <i className="far fa-external-link mr-2" />
        Training Resources
      </Button>
    </div>
  );
};

TrainingWidget.propTypes = {
  url: PropTypes.string,
};

export default TrainingWidget;
